export default "<p>go-url works!</p>\n"